export const tokens = {
	common: {
		languageChanged: "common.languageChanged",
	},
	nav: {
		files: "nav.files",
	},
};
